export function formatUsdPerMonth(value: number): string {
  return `$${value.toFixed(2)}`;
}
